import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AtendimentoSolicitacaoService } from '../../../../../services/atendimento-solicitacao.service';
import { ClienteService } from '../../../../../services/cliente.service';
import { FormValidations } from '../../../../../services/form-validations'

@Component({
  selector: 'ngx-atendimento-dependencia',
  templateUrl: './atendimento-dependencia.component.html',
  styleUrls: ['./atendimento-dependencia.component.scss']
})
export class AtendimentoDependenciaComponent implements OnInit {

  formulario: FormGroup

  public larguraPagina

  public Departamentos = []
  public TiposServico = []
  public Filiais = []

  constructor(private formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) data,
              public dialog: MatDialog,
              private dialogRef: MatDialogRef<AtendimentoDependenciaComponent>,
              
              private atendimentoSolicitacaoService: AtendimentoSolicitacaoService,
              private clienteService: ClienteService,) {
    
    this.larguraPagina = document.documentElement.clientWidth
      
    this.formulario = this.formBuilder.group({

      idSolicitacao: [0],
      idFilialFocus: [0],
      idTipoServico: [0],
      idResponsavel: [0],
      idDepartamento: [0],

      Departamento: [null, [Validators.required]],
      FilialFocus: [null, [Validators.required]],
      TipoServico: [null, [Validators.required]],
      Responsavel: [null], 
      Prazo: [null, [Validators.required]],
      Status: [null],
      Solicitacao: [null, [Validators.required]]
    })

    // INSERE OS DADOS NO SELECT DE DEPARTAMENTOS COM BASE NOS DADOS OBTIDOS ATRAVÉS DO SERVIÇO
    this.atendimentoSolicitacaoService.getDepartamentos()
    .then(
      response => {
        this.montarDepartamentosSelect(response)
      }
    )

    // MÉTODO INSERE TODAS AS FILIAIS NOS SELECT DE FILIAIS
    this.clienteService.getFiliais()
      .then(
        response => {
          this.montarFiliaisSelect(response)
        }
      )

  }

  ngOnInit(): void {
  }

  montarDepartamentosSelect(departamentos){
    departamentos.forEach(departamento => {
      this.Departamentos.push({value: departamento.Nome, viewValue: departamento.Nome, Id: departamento.Id})
    })
  }
  
  montarFiliaisSelect(filiais){
    filiais.forEach(filial => {
      this.Filiais.push({value: filial.NomeFilial, viewValue: `${filial.UF}-${filial.NomeFilial}`, Id: filial.Id})
    })

  }

  async mudaIdDepartamento(event){

    let idDepartamento = 0;
    this.TiposServico = []     

    for(let departamento of this.Departamentos){

      if (event.value == departamento.value){

        this.formulario.patchValue({
          idDepartamento: departamento.Id
        })

        idDepartamento = departamento.Id  
        break;
      }
    }

    await this.atendimentoSolicitacaoService.getTipoServico(idDepartamento)
      .then(
        response =>{
          response.forEach(linha => {
            this.TiposServico.push({value: linha.Descricao, viewValue: linha.Descricao, Id: linha.Id})
          })
        }
      )

      this.TiposServico.sort( (a,b) => {

        if(a.value > b.value){
          return 1;
        }
  
        if(a.value < b.value){
          return -1;
        }
  
        return 0;
        
      });
    
  }

  mudaIdTipoServico(event){

    for(let tipo of this.TiposServico){

      if(tipo.value == event.value){

        this.formulario.patchValue({
          idTipoServico: tipo.Id
        })

        break;
      }
    }
  }

  mudaIdFilial(event){
   
    for(let filial of this.Filiais){

      if (event.value == filial.value){

        this.formulario.patchValue({
          idFilialFocus: filial.Id
        })

        break;
      }
    }
  }

  alterarFormatoData(){

    let data = this.formulario.get('Prazo').value

    this.formulario.patchValue({
      Prazo: `${data}T00:00:00`
    })
  }

  fechar(){
    this.dialogRef.close()
  }

  gravar(){

    this.alterarFormatoData()
    this.dialogRef.close(this.formulario.value)

  }
}
